import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isMobile, currencyValue } from "utils/common";
import { quoteProductConfirmationColumns, quoteLaborConfirmationColumns } from "../utils";
import CustomTooltip from "common/tooltip";
import Button from "react-bootstrap/Button";
import MobileDataTable from "common/mobileDataTable";
import { displayMobileRowItem } from "../../common/mobileDataTable/utils";
import Modal from "common/modal";
import quote from "svg/quote.svg";
import { api } from "store/slices/api";
import "./style.scss";

const Confirmation = ({ setStage, productsData, laborData }) => {
  const { quoteId } = useParams();
  const navigate = useNavigate();
  const tableBodyNode = useRef();
  const tableBodySecondNode = useRef();
  const { sub } = useSelector((state) => state.loggedInUser);
  const { bulkPricesQuoteData } = useSelector((state) => state.priceQuote);
  const { data: quoteFields = {} } = api.useGetPriceQuoteQuery(quoteId);
  const [bulkUpdateQuotePrices] = api.useDeprecatedUpdateQuotePricesMutation();

  const [productsTableData, setProductsTableData] = useState();
  const [laborTableData, setLaborTableData] = useState();
  const [mobileView, setMobileView] = useState(false);
  const [isShowSaveModal, setIsShowSaveModal] = useState(false);
  const tdClass = "table-root-floor__body__tr__td table-root-floor__body__tr__td__text";

  useEffect(() => {
    const handleResize = () => {
      if (!isMobile()) {
        setMobileView(false);
      } else {
        setMobileView(true);
      }
    };
    window.addEventListener("resize", handleResize);
    if (isMobile()) {
      handleResize();
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileView]);

  useEffect(() => {
    const prodTableData = [];
    const temp1 = JSON.parse(JSON.stringify(productsData));
    const temp2 = JSON.parse(JSON.stringify(laborData));
    temp1.map((ele) => {
      if (ele.editedPrice) {
        ele.oldPrice = ele.price.toString();
        ele.price = ele.editedPrice;
        prodTableData.push(ele);
      }
    });
    const laborTabData = [];
    temp2.map((ele) => {
      if (ele.editedPrice) {
        ele.oldPrice = ele.price.toString();
        ele.price = ele.editedPrice;
        laborTabData.push(ele);
      }
    });
    setProductsTableData(prodTableData);
    setLaborTableData(laborTabData);
  }, [productsData, laborData]);

  const handlePreviousTab = () => {
    setStage("bulkUpdate");
  };

  const displayRowItem = (row, col) => {
    if (row && col && col.dataKey && row[col.dataKey]) {
      if (col.name && (col.name === "Product Name" || col.name === "Description")) {
        return (
          <CustomTooltip placement="top" text={row[col.dataKey]}>
            {row[col.dataKey]}
          </CustomTooltip>
        );
      }
      if (col.name && (col.name === "Old Price" || col.name === "Updated Price")) {
        return currencyValue(row[col.dataKey].toString());
      } else {
        return row[col.dataKey];
      }
    } else {
      return "";
    }
  };

  const materialRowsHeader = () => {
    return (
      <thead className="table-root-floor__header">
        <tr className="table-root-floor__header__tr">
          {quoteProductConfirmationColumns.map((col) => {
            return (
              <th
                key={col.id}
                className={`table-root-floor__header__tr__th table-root-floor__body__tr__td__text ${col.class}`}
              >
                <div>{col.name}</div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  const renderMaterialRows = () => {
    return productsTableData?.map((row, index) => {
      return (
        <tr key={index} className="table-root-floor__body__tr">
          {quoteProductConfirmationColumns.map((col) => {
            return (
              <>
                <td className={tdClass} key={index}>
                  {displayRowItem(row, col)}
                </td>
              </>
            );
          })}
        </tr>
      );
    });
  };

  const laborRowsHeader = () => {
    return (
      <thead className="table-root-floor__header">
        <tr className="table-root-floor__header__tr">
          {quoteLaborConfirmationColumns.map((col) => {
            return (
              <th
                key={col.id}
                className={`table-root-floor__header__tr__th table-root-floor__body__tr__td__text ${col.class}`}
              >
                <div>{col.name}</div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };

  const renderLaborRows = () => {
    return laborTableData?.map((row, index) => {
      return (
        <tr key={index} className="table-root-floor__body__tr">
          {quoteLaborConfirmationColumns.map((col) => {
            return (
              <>
                <td className={tdClass} key={index}>
                  {displayRowItem(row, col)}
                </td>
              </>
            );
          })}
        </tr>
      );
    });
  };

  const handleBulkUpdateQuote = () => {
    setIsShowSaveModal(true);
  };

  const handleSave = () => {
    let quoteData = JSON.parse(JSON.stringify(bulkPricesQuoteData));
    setIsShowSaveModal(false);
    let productsList = [];
    let laborList = [];
    quoteData.productDtoList.map((ele) => {
      productsTableData.map((prod) => {
        if (
          ((prod.salesNumber && ele.salesNumber && prod.salesNumber === ele.salesNumber) ||
            prod.productName === ele.productName) &&
          !productsList.includes(ele)
        ) {
          ele.updatedBy = sub;
          ele.oldPrice = parseFloat(prod.prcPrice);
          ele.price = parseFloat(prod.price);
          ele.extendedPrice = parseFloat(ele.price) * parseFloat(ele.quantity);
          ele.salesTax = ele.isTaxChecked ? parseFloat(quoteFields.taxRate / 100) * parseFloat(ele.extendedPrice) : 0;
          ele.total = parseFloat(ele.extendedPrice) + parseFloat(ele.salesTax);
          productsList.push(ele);
        }
      });
    });

    quoteData.laborCodesList.map((ele) => {
      laborTableData.map((labor) => {
        if (labor.laborCode === ele.laborCode && !laborList.includes(ele)) {
          ele.updatedBy = sub;
          ele.oldPrice = parseFloat(labor.oldPrice);
          ele.price = parseFloat(labor.price);
          ele.extendedPrice = parseFloat(ele.price) * parseFloat(ele.quantity);
          ele.salesTax = ele.isTaxChecked ? parseFloat(quoteFields.taxRate / 100) * parseFloat(ele.extendedPrice) : 0;
          ele.total = parseFloat(ele.extendedPrice) + parseFloat(ele.salesTax);
          laborList.push(ele);
        }
      });
    });

    const payload = { quoteId, productDtoList: productsList, laborCodesList: laborList };
    bulkUpdateQuotePrices(payload).then((res) => {
      if (res) {
        navigate(`/priceQuote/${quoteId}#quote-summary`);
      }
    });
  };

  const handleCancel = () => {
    setIsShowSaveModal(false);
  };
  const bulkProdPriceMobileRows = (currentData) => {
    return currentData.map((row, index) => {
      return (
        <div className="mobile-data__row__column__item" key={`${row.productId}-${index}`}>
          <div className="mobile-data__row__column__item__top hide-color">
            <div className="d-flex mobile-data__row__column__item__top__items">
              <div className="d-flex justify-content-between mobile-data__row__column__item__top__left ">
                <div
                  className="mobile-data__row__column__item__top__left__icon custom-collapse__container"
                  data-bs-toggle="collapse"
                  data-bs-target={"#collapse_" + row.productId + index}
                  aria-expanded="false"
                  aria-controls={"#collapse_" + row.productId + index}
                >
                  <span className="expand-collapse"></span>
                </div>
              </div>
              <div className="mobile-data__row__column__item__top__left__name">
                <span className="mobile-data__row__column__item__top__left__name--text">{row.productName}</span>
              </div>
            </div>
          </div>
          <div className="collapse mobile-data__row__column__item__content" id={"collapse_" + row.productId + index}>
            {quoteProductConfirmationColumns &&
              quoteProductConfirmationColumns.map((item, i) => {
                return (
                  <div key={i} className={`mobile-data__row__column__item__content__item ${item.classNameOne}`}>
                    <div className="mobile-data__row__column__item__content__item__flex">
                      <div className="mobile-data__row__column__item__content__item__flex--key">{item.keyName}:</div>
                      <div
                        className={`mobile-data__row__column__item__content__item__flex--value ${item?.classNameTwo ? item.classNameTwo : ""}`}
                      >
                        {displayMobileRowItem(row, item)}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
    });
  };
  const bulkLaborPriceMobileRows = (currentData) => {
    return currentData.map((row, index) => {
      return (
        <div className="mobile-data__row__column__item" key={`${row.laborCodeId}-${index}`}>
          <div className="mobile-data__row__column__item__top hide-color">
            <div className="d-flex mobile-data__row__column__item__top__items">
              <div className="d-flex justify-content-between mobile-data__row__column__item__top__left ">
                <div
                  className="mobile-data__row__column__item__top__left__icon custom-collapse__container"
                  data-bs-toggle="collapse"
                  data-bs-target={"#collapse_" + row.laborCodeId + index}
                  aria-expanded="false"
                  aria-controls={"#collapse_" + row.laborCodeId + index}
                >
                  <span className="expand-collapse"></span>
                </div>
              </div>
              <div className="mobile-data__row__column__item__top__left__name">
                <span className="mobile-data__row__column__item__top__left__name--text">{row.laborCode}</span>
              </div>
            </div>
          </div>
          <div className="collapse mobile-data__row__column__item__content" id={"collapse_" + row.laborCodeId + index}>
            {quoteLaborConfirmationColumns &&
              quoteLaborConfirmationColumns.map((item, i) => {
                return (
                  <div key={i} className={`mobile-data__row__column__item__content__item ${item.classNameOne}`}>
                    <div className="mobile-data__row__column__item__content__item__flex">
                      <div className="mobile-data__row__column__item__content__item__flex--key">{item.keyName}:</div>
                      <div
                        className={`mobile-data__row__column__item__content__item__flex--value ${item?.classNameTwo ? item.classNameTwo : ""}`}
                      >
                        {displayMobileRowItem(row, item)}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
    });
  };
  return (
    <div className="container-fluid search-form-container">
      <div className="search-form-container__title">
        <span className="search-form-container__title--text">
          <img src={quote} alt="quote" />
          &nbsp;Confirm Prices
        </span>
      </div>
      {productsTableData?.length > 0 && (
        <>
          <div className="bulk-header">Material Items</div>
          <div className="search-table-wrapper">
            <div className="container-fluid search-table">
              <MobileDataTable
                currentData={productsTableData}
                expandedItems={quoteProductConfirmationColumns}
                filteredList={[]}
                currencyValue={currencyValue}
                displaySearchFilter={false}
                isBulkProdPriceQuote={true}
                renderMobileRows={bulkProdPriceMobileRows}
              />
              <div className="table-responsive customer-search__table">
                <table id="example" className="table table-root-floor">
                  {materialRowsHeader()}
                  <tbody className="table-root-floor__body" ref={tableBodySecondNode}>
                    {productsTableData?.length > 0 ? (
                      renderMaterialRows()
                    ) : (
                      <tr>
                        <td colSpan={12} className="no-results--text text-center">
                          Zero results were found based on your search criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
      {laborTableData?.length > 0 && (
        <>
          <div className="bulk-header">Labor Items</div>
          <div className="search-table-wrapper">
            <div className="container-fluid search-table">
              <MobileDataTable
                currentData={laborTableData}
                expandedItems={quoteLaborConfirmationColumns}
                filteredList={[]}
                currencyValue={currencyValue}
                displaySearchFilter={false}
                isBulkLaborPriceQuote={true}
                renderMobileRows={bulkLaborPriceMobileRows}
              />
              <div className="table-responsive customer-search__table">
                <table id="example" className="table table-root-floor">
                  {laborRowsHeader()}
                  <tbody className="table-root-floor__body" ref={tableBodyNode}>
                    {laborTableData?.length > 0 ? (
                      renderLaborRows()
                    ) : (
                      <tr>
                        <td colSpan={12} className="no-results--text text-center">
                          Zero results were found based on your search criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="d-flex justify-content-between flex-column flex-md-row mt-10 footer-spacing">
        <Button variant="outline-primary" onClick={handlePreviousTab}>
          Back
        </Button>
        <Button onClick={handleBulkUpdateQuote}>Confirm Bulk Update</Button>
      </div>
      {isShowSaveModal && (
        <Modal
          title={"Confirm Bulk update Prices"}
          saveButtonText={"Confirm"}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          size={mobileView ? "sm" : "lg"}
        >
          <p className="confirmation-text">Are you sure you want to update Prices in Quote?</p>
        </Modal>
      )}
    </div>
  );
};

export default Confirmation;
